/*
 * @Description: 首页文件入口文件
 * @Author: 王振
 * @Date: 2021-05-28 14:51:45
 * @LastEditors: 三棵杨树
 * @LastEditTime: 2023-08-31 10:56:51
 */
import Vue from "Vue";
import system from "./system.vue";
import Router from "vue-router";
import Vuex from "vuex";
import router from "./router";
import store from "./store";
import "bootstrap3/dist/css/bootstrap.min.css";
import "bootstrap3/dist/js/bootstrap.min";
import {
  Button,
  Input,
  Form,
  FormItem,
  Table,
  TableColumn,
  DatePicker,
  Checkbox,
  Dialog,
  Main,
  Container,
  Pagination,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Link,
  Tabs,
  TabPane,
  Row,
  Col,
  Popover,
  Message,
  Select,
  Option,
  Image,
} from "element-ui";

Vue.config.productionTip = false;
Vue.prototype.$message = Message;

//使用路由和vuex
Vue.use(Router);
Vue.use(Vuex);
//使用element组件
Vue.use(Button);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Checkbox);
Vue.use(Dialog);
Vue.use(Main);
Vue.use(Container);
Vue.use(Pagination);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Link);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Row);
Vue.use(Col);
Vue.use(Popover);
Vue.use(Select);
Vue.use(Option);
Vue.use(Image);

// 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(system),
});



// WEBPACK FOOTER //
// ./src/pages/system/system.js